module.exports = __webpack_public_path__ + "img/Bear12.84b307a9.jpg";